import type { Navigation } from "zudoku";
import { StandardIntegration } from "./src/standard-integration";

export const navigation: Navigation = [
    {
      type: "category",
      label: "Документация",
      items: [
        { type: "filter", placeholder: "Поиск по оглавлению" },
        {
          type: "category",
          label: "Общее",
          items: [
            "/docs/api-usage-recommendations",
            {
              type: "category",
              label: "Javascript SDK",
              link: {
                type: "doc",
                file: "/docs/javascript-sdk"
              },
              items: [
                {
                  "type": "doc",
                  "label": "Анонимизатор",
                  "file": "docs/javascript-sdk-anonymization",
                }
              ]
            },
            "/docs/website-authorization-ticket",
            {
              type: "category",
              label: "V3 API",
              link: {
                type: "doc",
                file: "/docs/v3"
              },
              items: [
                "/docs/error_processing",
                "/docs/api-restrictions"
              ]
            },
            "/docs/data-import-limitations"
          ],
        },

        {
          type: "category",
          label: "Клиент",
          items: [
            {
              type: "category",
              label: "Регистрация, формы подписки, трекинг входа на сайт",
              link: {
                type: "doc",
                file: "/docs/registration-authorization-subscription"
              },
              items: [
                "/docs/userregxml",
                "/docs/userregjson",
                "/docs/json"
              ]
            },
            {
              type: "category",
              label: "Аутентификация",
              link: {
                type: "doc",
                file: "/docs/authentication"
              },
              items: [
                "/docs/password-based-authentication",
                "/docs/secret-code-authentication",
                "/docs/ticket-authentication",
              ]
            },
            {
              type: "category",
              label: "Редактирование данных клиента",
              link: {
                type: "doc",
                file: "/docs/account-data-editing"
              },
              items: [
                "/docs/userredxml",
                "/docs/userredjson",
                "/docs/userredjson-1"
              ]
            },
            "/docs/referral-code-registration",
            "/docs/mobile-phone-verification",
            "/docs/customers-import-v3",
            "/docs/bulk-import-cards-clients",
            "/docs/get-customer-data",
            "/docs/customer-existence-database-check",
            "/docs/send-confirmation-code",
            "/docs/on-demand-customer-merging",
            "/docs/phone-verification-client-side",
            "/docs/customers-edit-v3",
            "/docs/time-zone-edit",
            "/docs/bulk-import-customer-actions",
            "/docs/blacklist"
          ],
        },

        {
          type: "category",
          label: "Сегментации",
          items: [
            "/docs/add-customer-to-segment",
            "/docs/remove-customer-from-segmentation",
            "/docs/get-customer-segments",
            "/docs/get-project-segments-list",
            "/docs/static-customer-segments-v3",
            "/docs/static-product-segments",
          ],
        },

        {
          type: "category",
          label: "Заказы",
          items: [
            "/docs/order-checkout",
            "/docs/update-order",
            "/docs/update-order-line-status",
            "/docs/retailorder-import-v3",
            "/docs/get-total-paid-orders-amount",
            "/docs/get-customer-orders-list",
            "/docs/get-order-info",
            "/docs/preorder",
            "/docs/create-order-with-processing",
            "/docs/processing-calculate-product-list",
            "/docs/processing-offline-order",
            "/docs/get-orders-list",
          ],
        },

        {
          type: "category",
          label: "Номенклатура",
          items: [
            {
              type: "category",
              label: "Импорт продуктов",
              link: { type: "doc", file: "/docs/product-import" },
              items: [
                "/docs/prodimportxml",
                "/docs/prodimportcsv",
              ],
            },

            "/docs/regional-products-import",

            {
              type: "category",
              label: "Импорт категорий продуктов",
              link: {
                type: "doc",
                file: "/docs/product-category-import",
              },
              items: [
                {
                  type: "link",
                  label: "xml",
                  to: "/docs/prodimportxml",
                },
                "/docs/catimportcsv",
              ],
            },

            {
              type: "category",
              label: "Действия с продуктами",
              link: { type: "doc", file: "/docs/product-actions" },
              items: [
                "/docs/prodactionxml",
                "/docs/prodactionjson",
              ],
            },

            {
              type: "category",
              label: "Действия с категориями",
              link: {
                type: "doc",
                file: "/docs/product-category-actions",
              },
              items: [
                "/docs/catactionxml",
                "/docs/catactionjson",
              ],
            },

            {
              type: "category",
              label: "Действия со списками продуктов",
              link: {
                type: "doc",
                file: "/docs/product-list-actions",
              },
              items: [
                "/docs/prodlistactionxml",
                "/docs/prodlistactionjson",
              ],
            },

            "/docs/import-personalproductlist-v3",
            "/docs/get-customer-product-list",
            "/docs/bulk-add-products-to-list-v3",
            "/docs/update-product",
            "/docs/update-product-category",
            "/docs/save-product-regional-info",
            "/docs/import-personal-offers",
            "/docs/delete-categories",
          ],
        },

        {
          type: "category",
          label: "Промокоды и промоакции",
          items: [
            "/docs/bind-promocode",
            "/docs/redeem-promocode",
            "/docs/cancel-promocode-redemption",
            "/docs/bulk-import-promocodes-v3",
            "/docs/get-promocodes-list",
            "/docs/bulk-import-promocode-pools-v3",
            "/docs/save-external-promotion",
            "/docs/import-external-promotions",
            "/docs/get-promotions-for-customer",
            "/docs/set-personal-offers-list",
            "/docs/get-personal-offers-list",
            "/docs/archive-external-promotions",
          ],
        },

        {
          type: "category",
          label: "Бонусный счет",
          items: [
            "/docs/get-customer-bonus-balance",
            "/docs/update-customer-bonus-account",
            "/docs/get-customer-bonus-balance-history",
            "/docs/bulk-import-balance-changes-v3",
          ],
        },

        {
          type: "category",
          label: "Рекомендации",
          items: ["/docs/get-popular-products"],
        },

        {
          type: "category",
          label: "Рассылки",
          items: [
            {
              type: "category",
              label: "Отправка рассылок по API",
              link: { type: "doc", file: "/docs/api-mailings-send" },
              items: [
                "/docs/tranletterxml",
                "/docs/mailings-send-json",
                "/docs/json-1",
              ],
            },

            "/docs/upload-attachments-for-emails",

            {
              type: "link",
              label: "Цифровые подписи",
              to: "https://help.mindbox.ru/docs/%D0%BA%D0%B0%D0%BA-%D0%BD%D0%B0%D1%81%D1%82%D1%80%D0%BE%D0%B8%D1%82%D1%8C-dkim-%D0%B8-dmarc",
            },

            {
              type: "category",
              label: "Вебпуши",
              items: ["/docs/get-firebase-keys-for-web-push"],
            },
          ],
        },

        {
          type: "category",
          label: "Чат-боты",
          items: [

            "/docs/chat-bots-methods",
            "/docs/chatbot-authorization",
            "/docs/chat-bots-qr-authentication"
          ]
        },

        {
          type: "category",
          label: "Карты",
          items: [
            "/docs/get-discount-card-details",
            "/docs/get-customer-discount-cards-list",
            "/docs/customer-card-activation",
            "/docs/change-card-status-at-pos",
            "/docs/change-card-status-in-account",
            "/docs/replace-card",
            "/docs/bulk-import-gift-card-pool-v3",
            "/docs/bulk-import-discount-card-pool-v3",
            "/docs/bulk-import-discount-card-statuses-v3",
            "/docs/bind-discount-card-with-sms-confirmation",
            "/docs/unbind-discount-card",
            "/docs/gift-cards-in-order-save-operations",
            {
              "type": "doc",
              "label": "Блокировка подарочных карт",
              "file": "/docs/block-gift-cards",
              "badge": { "label": "New", "color": "green" },
            },
          ],
        },

        {
          type: "category",
          label: "Точки контакта, магазины, зоны",
          items: [
            "/docs/bulk-import-touchpoints-v3",
            "/docs/bulk-import-zones-v3",
            "/docs/bulk-delete-zones-v3",
            "/docs/bulk-import-channels-v3",
            {
              "type": "doc",
              "label": "Массовый импорт магазинов",
              "file": "/docs/import-bulk-stores",
            },
          ],
        },

        {
          type: "category",
          label: "Экспорты",
          items: [
            "/docs/exports-overview",
            "/docs/export-ftps-sftp",
            "/docs/export-customers",
            {
              "type": "doc",
              "label": "Экспорт регистраций клиентов",
              "file": "/docs/export-customer-registrations",
              "badge": { "label": "New", "color": "green" },
            },
            "/docs/export-customer-merges",
            "/docs/export-customer-segmentation-changes",
            "/docs/export-customer-actions",
            "/docs/export-product-segmentation-changes",
            "/docs/export-orders-and-lines",
            "/docs/export-promotions",
            "/docs/export-mailings",
            "/docs/export-mailing-statuses",
            "/docs/export-api-reports",
            "/docs/export-scenarios",
            "/docs/export-customers-from-scenario-blocks",
            "/docs/export-operation-logs",
            "/docs/export-webhook-logs",
            "/docs/export-event-log",
          ],
        },

        {
          type: "category",
          label: "Данные для аналитики",
          items: [
            "/docs/how-to-read-data",

            {
              type: "category",
              label: "Описание схемы данных",
              link: {
                type: "doc",
                file: "/docs/analytics-data-schema",
              },
              items: [
                "/docs/customer-bonus-balance-change-events",
                "/docs/bonus-promotions-reference",
                "/docs/link-between-bonus-redemptions-and-accruals",
                "/docs/bonus-accounts-reference",
                "/docs/customer-orders",
                "/docs/external-order-ids",
                "/docs/customer-order-lines",
                "/docs/order-line-statuses-reference",
                "/docs/touchpoints-reference",
                "/docs/mailings-reference",
                "/docs/mailing-topics-reference",
                "/docs/tags-reference",
                "/docs/tags-in-mailings",
                "/docs/mailing-statuses",
                "/docs/segmentations-reference",
                "/docs/segments-reference",
                "/docs/customer-segments-history",
                "/docs/customer-merges",
                "/docs/folders-reference",
                "/docs/ab-tests-reference",
                "/docs/ab-test-variants-reference",
                "/docs/ab-test-participants",
                "/docs/customfields-reference",
                "/docs/external-ids-change-history",
                "/docs/external-systems",
                "/docs/product-external-ids",
                {
                  "type": "doc",
                  "label": "Справочник категорий действий",
                  "file": "/docs/action-categories-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник шаблонов действий",
                  "file": "/docs/action-templates-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Теги в шаблонах действий",
                  "file": "/docs/tags-in-action-templates",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник каналов",
                  "file": "/docs/channels-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник пулов промокодов",
                  "file": "/docs/promo-code-pools-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Промокоды",
                  "file": "/docs/promo-codes",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник категорий продуктов",
                  "file": "/docs/product-categories-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Продукты в категориях",
                  "file": "/docs/products-in-categories",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник сценариев",
                  "file": "/docs/scenarios-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник версий сценариев",
                  "file": "/docs/scenario-versions-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник блоков сценариев",
                  "file": "/docs/scenario-blocks-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Справочник механик персонализации",
                  "file": "/docs/personalization-mechanics-reference",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Показы механик персонализации",
                  "file": "/docs/personalization-views",
                  "badge": { "label": "New", "color": "green" },
                },
                {
                  "type": "doc",
                  "label": "Клики по механикам персонализации",
                  "file": "/docs/personalization-clicks",
                  "badge": { "label": "New", "color": "green" },
                },

              ],
            },

            {
              type: "category",
              label: "Как периодически обновлять данные",
              link: {
                type: "doc",
                file: "/docs/periodic-data-updates",
              },
              items: [
                "/docs/how-to-work-with-customer-merges",
                "/docs/reconcile-orders-with-report",
                "/docs/calculate-loyalty-points-balance",
                {
                  "type": "doc",
                  "label": "Как получить внешний ID клиента",
                  "file": "/docs/external-customer-id-in-analytics-exports",
                },
              ],
            },
          ],
        },

        {
          type: "category",
          label: "Стандартные интеграции",
          items: [
            "/docs/php-sdk",
            {
              "type": "doc",
              "label": "Bitrix",
              "file": "/docs/bitrix-integration"
            }, 
            {
              "type": "doc",
              "label": "Passteam",
              "file": "/docs/passteam-integration"
            }, 
            {
              "type": "doc",
              "label": "OSMI Cards",
              "file": "/docs/osmi-cards-integration"
            }, 

            {
              type: "category",
              label: "Приложение «Кошелёк»",
              link: {
                type: "doc",
                file: "/docs/koshelek-app-integration",
              },
              items: [
                {
                  "type": "doc",
                  "label": "Механики для модуля лояльности",
                  "file": "/docs/create-integration-for-cdp-and-loyalty-module"
                }, 
                {
                  "type": "doc",
                  "label": "Механики для отправки push-уведомлений",
                  "file": "/docs/cardsmobile-integration-mechanics-for-loyalty-module"
                }, 
              ],
            },

            {
              "type": "doc",
              "label": "Frontol",
              "file": "/docs/frontol-integration"
            }, 
            {
              "type": "doc",
              "label": "Set Retail",
              "file": "/docs/set-retail-integration"
            },
            {
              "type": "doc",
              "label": "1С:Розница",
              "file": "/docs/1c-retail-module-integration"
            },
            {
              "type": "doc",
              "label": "Albato",
              "file": "/docs/albato-integration"
            },

            {
              type: "category",
              label: "iiko",
              link: {
                type: "doc",
                file: "/docs/iiko-integration",
              },
              items: [
                "/docs/iiko-pos-instructions",
                "/docs/iiko-plugin-setup-version-n-plus",
              ],
            },

            {
              "type": "doc",
              "label": "rkeeper",
              "file": "/docs/rkeeper-integration"
            },            
            {
              "type": "doc",
              "label": "Segmel",
              "file": "/docs/segmel-integration"
            },                
          ],
        },

        {
          type: "category",
          label: "Мобильные приложения",
          items: [
            "/docs/mindbox-sdk",

            {
              type: "category",
              label: "iOS SDK",
              link: { type: "doc", file: "/docs/ios-sdk" },
              items: [
                "/docs/add-ios-integration",
                "/docs/sandbox-integration-setup",
                "/docs/apns-keys-setup",
                {
                  "type": "doc",
                  "label": "Упрощенная интеграция",
                  "file": "/docs/ios-easy-integration",
                },
                "/docs/add-sdk-to-app",
                "/docs/ios-sdk-initialization",
                "/docs/ios-quick-setup-push-notifications",

                {
                  type: "category",
                  label: "Настройка Rich-push уведомлений",
                  link: {
                    type: "doc",
                    file: "/docs/ios-rich-push-notifications",
                  },
                  items: [
                    "/docs/rich-push-notifications-preview",
                    "/docs/rich-push-notifications-buttons",
                  ],
                },

                "/docs/ios-push-notification-deep-linking",
                "/docs/ios-push-click-forwarding",
                "/docs/ios-guarantee-delivery-setup",
                "/docs/ios-get-app-install-source",
                "/docs/ios-integration-actions",
                "/docs/ios-sdk-configuration-fields",
                "/docs/ios-sdk-request-constructor",
                "/docs/ios-push-notification-format",
                "/docs/ios-sdk-events",
                "/docs/ios-sdk-methods",
                "/docs/ios-webview-sync-with-sdk",
                {
                "type": "doc",
                "label": "Пуши из нескольких источников отправки",
                "file": "docs/ios-push-notifications-from-multiple-sources"
                      }
              ],
            },

            {
              type: "category",
              label: "Android SDK",
              link: { type: "doc", file: "/docs/android-sdk" },
              items: [
                "/docs/add-android-integration",

                {
                  type: "category",
                  label: "Получение ключей провайдеров пушей",
                  link: {
                    type: "doc",
                    file: "/docs/android-push-provider-keys",
                  },
                  items: [
                    "/docs/firebase-key-setup",
                    "/docs/huawei-get-keys",
                    "/docs/rustore-get-keys",
                  ],
                },
                {
                  "type": "doc",
                  "label": "Упрощенная интеграция",
                  "file": "/docs/android-easy-integration",
                },
                "/docs/add-android-sdk",
                "/docs/android-sdk-initialization",
                "/docs/firebase-send-push-notifications",
                "/docs/huawei-send-push-notifications",
                "/docs/rustore-send-push-notifications",
                "/docs/android-get-click",
                "/docs/android-app-start-tracking",
                "/docs/android-integration-of-actions",
                "/docs/android-sdk-configuration",
                "/docs/android-sdk-response-body",
                "/docs/android-sdk-request-body",
                "/docs/android-push-notification-format",
                "/docs/android-sdk-methods",
                "/docs/v1-v2-android-sdk",
                "/docs/sync-deviceuuid-between-mobile-sdk-and-js-sdk-webview",
                "/docs/how-to-receive-push-notifications-from-multiple-sources",
              ],
            },

            {
              type: "category",
              label: "Flutter SDK",
              link: { type: "doc", file: "/docs/flutter-sdk" },
              items: [
                "/docs/flutter-new-integration-setup",
                "/docs/flutter-get-push-keys",
                "/docs/add-sdk-flutter",
                "/docs/flutter-sdk-initialization",
                "/docs/ios-send-push-notifications-flutter",

                {
                  type: "category",
                  label: "Android | Настройка пуш-уведомлений",
                  link: {
                    type: "doc",
                    file: "/docs/flutter-android-push-notifications-setup",
                  },
                  items: [
                    "/docs/firebase-send-push-notifications-flutter",
                    "/docs/huawei-send-push-notifications-flutter",
                    "/docs/rustore-send-push-notifications-flutter",
                  ],
                },

                {
                  type: "category",
                  label: "iOS | Настройка Rich-push уведомлений",
                  link: {
                    type: "doc",
                    file: "/docs/flutter-ios-rich-push-notifications",
                  },
                  items: [
                    "/docs/ios-rich-push-image-preview",
                    "/docs/ios-rich-push-image-and-button",
                  ],
                },

                "/docs/ios-get-click-flutter",
                "/docs/flutter-push-navigation",
                "/docs/ios-setup-background-tasks-flutter",
                "/docs/ios-app-start-tracking-flutter",
                "/docs/integration-actions-flutter",
                "/docs/flutter-sdk-methods",
                "/docs/sync-deviceuuid-between-mobile-sdk-and-js-sdk-webview-flutter",
              ],
            },

            {
              type: "category",
              label: "React Native SDK",
              link: {
                type: "doc",
                file: "/docs/react-native-sdk",
              },
              items: [
                "/docs/add-integration-rn",
                "/docs/rn-get-push-keys",
                "/docs/add-sdk-react-native",
                "/docs/sdk-initialization-react-native",
                "/docs/ios-send-push-notifications-react-native",

                {
                  type: "category",
                  label: "Android | Настройка пуш-уведомлений",
                  link: {
                    type: "doc",
                    file: "/docs/rn-android-push-notifications-setup",
                  },
                  items: [
                    "/docs/firebase-send-push-notifications-react-native",
                    "/docs/huawei-send-push-notifications-react-native",
                    "/docs/rustore-send-push-notifications-react-native",
                  ],
                },

                {
                  type: "category",
                  label: "iOS | Настройка Rich-push уведомлений",
                  link: {
                    type: "doc",
                    file: "/docs/rn-ios-rich-push-notifications",
                  },
                  items: [
                    "/docs/ios-rich-push-image-preview-react-native",
                    "/docs/ios-rich-push-image-and-button-react-native",
                  ],
                },

                "/docs/android-get-click-react-native",
                "/docs/ios-get-click-react-native",
                "/docs/flutter-push-navigation-react-native",
                "/docs/ios-setup-background-tasks-react-native",
                "/docs/ios-app-start-tracking-react-native",
                "/docs/integration-actions-react-native",
                "/docs/react-native-sdk-methods",
                "/docs/sync-deviceuuid-between-mobile-sdk-and-js-sdk-webview-react-native",
              ],
            },

            {
              type: "category",
              label: "Expo SDK",
              link: {
                type: "doc",
                file: "/docs/expo-sdk",
              },
              items: [
                {
                  type: "link",
                  label: "Настройка точек интеграции",
                  to: "/docs/add-integration-rn",
                },
                "/docs/expo-sdk-setup",
                {
                  type: "category",
                  label: "Дополнительные настройки",
                  items: [
                    "/docs/push-navigation-expo",
                    {
                      type: "link",
                      label: "Интеграция действий в приложении",
                      to: "/docs/integration-actions-react-native",
                    },
                    {
                      type: "link",
                      label: "Доступные методы",
                      to: "/docs/react-native-sdk-methods",
                    },
                    "/docs/expo-notification",
                  ]
                }
              ],
            },

            {
              type: "category",
              label: "In-App",
              link: { type: "doc", file: "/docs/in-app" },
              items: [
                "/docs/in-app-targeting-by-custom-operation",
                "/docs/in-app-operation-category-and-product-targeting",
              ],
            },

            {
              type: "category",
              label: "Центр уведомлений",
              items: [
                {
                  type: "doc",
                  label: "Через SDK Mindbox",
                  file: "/docs/notification-center",
                },
                {
                  type: "doc",
                  label: "Через модуль «Уведомления и мессенджеры»",
                  file: "/docs/notification-center-integration",
                  badge: { label: "New", color: "green" },
                },
              ],
            },
            "/docs/universal-links",

            {
              type: "category",
              label: "Справочное",
              link: {
                type: "doc",
                file: "/docs/mobile-sdk-reference",
              },
              items: [
                "/docs/sdk-subscribe-customer",
                "/docs/mobile-push-check",
              ],
            },

            {
              type: "category",
              label: "Чек-лист проверки интеграции SDK",
              link: {
                type: "doc",
                file: "/docs/sdk-integration-checklist",
              },
              items: [
                {
                  type: "category",
                  label: "Общее",
                  link: {
                    type: "doc",
                    file: "/docs/sdk-checklist-general",
                  },
                  items: [
                    "/docs/sdk-checklist-app-started-console-error",
                    "/docs/sdk-checklist-console-error-when-sending-request",
                    "/docs/sdk-checklist-user-not-receiving-push",
                  ],
                },

                {
                  type: "category",
                  label: "IOS",
                  link: {
                    type: "doc",
                    file: "/docs/sdk-checklist-ios",
                  },
                  items: [
                    "/docs/sdk-checklist-build-error",
                    "/docs/sdk-checklist-installation-status-not-registered",
                    "/docs/sdk-checklist-no-push-permission",
                    "/docs/sdk-checklist-push-no-small-image",
                    "/docs/sdk-checklist-push-no-large-image",
                    "/docs/sdk-checklist-push-no-large-image-on-click",
                    "/docs/sdk-checklist-push-click-not-tracked-in-mindbox",
                    "/docs/sdk-checklist-click-called-but-not-saved",
                    "/docs/sdk-checklist-wrong-token",
                    "/docs/sdk-checklist-wrong-environment-all-tokens-invalid",
                    "/docs/sdk-checklist-contractmismatch-ios",
                  ],
                },
                
                {
                  type: "category",
                  label: "Android",
                  link: {
                    type: "doc",
                    file: "/docs/sdk-checklist-android",
                  },
                  items: [
                    "/docs/sdk-checklist-installation-status-not-registered-android",
                    "/docs/sdk-checklist-sent-but-not-displayed",
                    "/docs/sdk-checklist-push-missing-text-icon",
                    "/docs/sdk-checklist-push-not-as-expected",
                    "/docs/sdk-checklist-push-icon-wrong-color",
                    "/docs/sdk-checklist-push-no-image",
                    "/docs/sdk-checklist-push-buttons-not-working",
                    "/docs/sdk-checklist-push-click-not-tracked-in-mindbox-android",
                    "/docs/sdk-checklist-push-click-did-not-open-section",
                    "/docs/sdk-checklist-app-crashes-after-notifications",
                    "/docs/sdk-checklist-wrong-token-or-invalid-tokens",
                    "/docs/sdk-checklist-contractmismatch",
                  ],
                },
                
              ],
            },
          ],
        },

        {
          type: "category",
          label: "Персонализация сайта",
          items: [
            "/docs/website-personalization",

            {
              type: "category",
              label: "Базовая интеграция",
              link: {
                type: "doc",
                file: "/docs/website-personalization-basic-integration",
              },
              items: [
                "/docs/tracker-installation",
                "/docs/step-2-run-mechanics",
                "/docs/step-3-connect-module",
                "/docs/step-4-verify-basic-integration",
              ],
            },

            {
              type: "category",
              label: "Расширенная интеграция",
              link: {
                type: "doc",
                file: "/docs/website-personalization-advanced-integration",
              },
              items: [
                {
                  type: "category",
                  label: "Фронтенд",
                  link: {
                    type: "doc",
                    file: "/docs/website-personalization-frontend",
                  },
                  items: [
                    "/docs/step-1-create-operations-for-frontend",
                    "/docs/step-2-call-operations-with-javascript-sdk",
                    "/docs/step-3-website-personalization-settings-at-integration-point",
                  ],
                },

                {
                  type: "category",
                  label: "Бэкенд",
                  link: {
                    type: "doc",
                    file: "/docs/website-personalization-backend",
                  },
                  items: [
                    "/docs/step-1-create-operations-for-backend",
                    "/docs/step-2-call-operations-from-backend-or-external-system",
                    "/docs/step-3-call-operations-for-personalization",
                    "/docs/step-4-website-personalization-settings-for-backend-integration",
                  ],
                },

                "/docs/verify-advanced-integration",
              ],
            },

            {
              type: "category",
              label: "Особенности установки виджетов рекомендаций на сайте",
              link: {
                type: "doc",
                file: "/docs/website-recommendation-widgets-installation",
              },
              items: [
                "/docs/widget-placement-with-advanced-integration",
                "/docs/widget-placement-without-advanced-integration",
              ],
            },

            {
              type: "category",
              label: "Чеклист проверки интеграции персонализации",
              items: [
                {
                  type: "category",
                  label: "Механика не работает по тестовой ссылке",
                  link: {
                    type: "doc",
                    file: "/docs/mechanics-not-working-test-link",
                  },
                  items: [
                    "/docs/tracker-not-installed",
                    "/docs/tracker-installed-incorrectly",
                    "/docs/scripts-not-installed",
                    "/docs/mechanics-missing-required-settings",
                    "/docs/mechanics-wrong-endpoint",
                    "/docs/website-has-redirects",
                    "/docs/incorrect-display-location",
                  ],
                },

                {
                  type: "category",
                  label: "Виджет рекомендаций не работает по тестовой ссылке",
                  link: {
                    type: "doc",
                    file: "/docs/widget-not-working-test-link",
                  },
                  items: [
                    "/docs/no-products-for-recommendation",
                    "/docs/widget-not-displayed-for-product",
                    "/docs/widget-not-displayed-for-category",
                  ],
                },

                {
                  type: "category",
                  label: "Механика персонализации включена, но не показывается клиенту",
                  link: {
                    type: "doc",
                    file: "/docs/mechanics-enabled-not-shown",
                  },
                  items: [
                    "/docs/targeting-conditions-conflict",
                    "/docs/device-not-linked-to-target-customer",
                    "/docs/impression-limit-exceeded",
                    "/docs/targeting-uses-product-conditions-but-data-not-sent",
                    "/docs/google-optimize-ab-test-ended",
                  ],
                },

                {
                  type: "category",
                  label: "Механика персонализации отображается, игнорируя условия таргетинга",
                  items: [
                    "/docs/segment-updated-without-page-reload",
                    "/docs/cart-changed-does-not-match-targeting",
                    "/docs/spa-navigation-without-reload",
                  ],
                },

                "/docs/mechanics-loads-slowly",
              ],
            },
          ],
        },

        {
          type: "category",
          label: "Разное",
          items: [
            "/docs/import-field-values", 
            "/docs/import-status",
            "/docs/sla-integration",
            "/docs/integrations-monitoring-api",
            "/docs/monitoring-webhooks",
            "/docs/workflow-startup",
        ],
        }

      ],
    },
    {
      type: "custom-page",
      path: "/page/standard-integration",
      label: "Стандартные интеграции",
      element: <StandardIntegration />,
    },
    {
      type: "doc",
      file: "/docs/mailings",
      path: "/page/mailings",
      label: "Рассылки",
    },
    {
      type: "doc",
      file: "/docs/website-recommendations",
      path: "/page/website-recommendations",
      label: "Персонализация сайта",
    },
    {
      type: "doc",
      file: "/docs/loyalty-pos",
      path: "/page/loyalty-pos",
      label: "Лояльность",
    },     
    {
      type: "doc",
      file: "/docs/webpush",
      path: "/page/webpush",
      label: "Вебпуши",
    },
    {
      type: "doc",
      file: "/docs/webhook",
      path: "/page/webhook",
      label: "Вебхуки",
    },
    {
      type: "link",
      label: "Мобильные приложения",
      to: "/docs/mindbox-sdk",
    },
]